<template>
  <div class="hub">
    <div class="flex justify-between items-center pb-6 shadow-border-b gap-8 mdmax:flex-col mdmax:gap-2">
      <div class="w-1/5 mdmax:w-full">
        <LinkButton buttonText="Tambah Hub/Drop Point" url="/hub/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="w-4/5 flex justify-end gap-8 mdmax:justify-start mdmax:w-full mdmax:flex-col mdmax:gap-2">
        <div class="w-3/12 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Provinsi</label>
          <CustomSelect :options="provinces" v-model="selectedProvince" optionLabel="name" />
        </div>
        <div class="w-3/12 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Kota/Wilayah</label>
          <CustomSelect :options="cities" class="select" v-model="selectedArea" optionLabel="name" :enableSearch="true" @search="doSearch" />
        </div>
        <div class="w-6/12 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Nama hub, wilayah, PIC, Kode Hub" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat rincian" :url="`/hub/detail/${entry.id}`" linkType="internal" type="secondary" size="small" />
        <span class="block" v-else-if="column.field === 'primary_pic_name'">
          {{ entry.primary_pic_name }}
          <span class="block text-sm text-neutral-500">{{ entry.primary_pic_phoneno }}</span>
        </span>
        <span class="block" v-else-if="column.field === 'secondary_pic_name'">
          {{ entry.secondary_pic_name }}
          <span class="block text-sm text-neutral-500">{{ entry.secondary_pic_phoneno }}</span>
        </span>
        <span class="block " v-else-if="column.field === 'area_code'">
          {{ getAreaName(entry.area_code) }}
        </span>
        <span v-else>{{ entry[column.field] || '-' }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data: () => ({
    typeList: ['Semua', 'Pickup', 'Pengiriman'],
    aList: [
      {
        id: 1,
        value: 'Semua'
      },
      {
        id: 2,
        value: 'Pickup'
      }
    ],
    selectedProvince: '',
    selectedArea: null,
    columns: [
      // { label: 'ID', field: 'id' },
      { label: 'Kode Hub', field: 'hub_code' },
      { label: 'Nama Hub', field: 'name' },
      { label: 'Provinsi', field: 'province_name' },
      { label: 'Kota/Wilayah', field: 'district_name' },
      { label: 'PIC 1', field: 'primary_pic_name' },
      { label: 'PIC 2', field: 'secondary_pic_name' },
      { label: 'Action', field: 'action' }
    ],
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10,
    hasMorePages: true
  }),
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('hub', ['hub']),
    ...mapGetters('master', ['cities', 'provinces']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    filteredData() {
      let temp = this.hub
      temp = temp.filter(item => {
        return item.code !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    this.getCityList()
    this.getProvinceList()
    if (!this.$route.query.page) {
      this.$router.push({ path: '/hub', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getHubList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getHubList()
      } else {
        this.$router.push({ path: '/hub', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('hub', ['getHub']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('master', ['getCities', 'getProvinces']),
    getAreaName(code) {
      return this.cities?.filter(item => item.code === code)[0]?.name
    },
    getProvinceList() {
      this.getProvinces()
    },
    getCityList() {
      this.getCities({
        params: {
          page: 1,
          per_page: 1000,
          search_keyword: ''
        }
      })
    },
    doSearch() {
      this.getHub(this.searchTerm)
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/armada/partner', query: { page: page } })
    },
    getHubList(searchTerm = '') {
      this.getHub({
        partnerId: this.partnerId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    }
  }
}
</script>
